import type { Reward } from '@/interfaces/user.interface'
import { HttpMethod, Performer } from './core'

export class Visit extends Performer<void, Reward | undefined> {
  protected method = HttpMethod.POST
  protected url = '/visit'
}
